<template>
  <div class="app-auto-top-up">
    Die einfachste und komfortabelste Art, immer genügend Guthaben zu haben, ist die automatische
    Aufladung. Dein Guthaben wird regelmäßig bei Unterschreitung einer bestimmten Guthabengrenze
    oder jeweils zum 2. jedes Monats automatisch aufgeladen. Die Einstellungen kannst du
    nachträglich jederzeit ändern.
    <b-col cols="12">
      <b-form-group :class="['byLimit-group', { 'not-active':  topUp.type !== 'byLimit' }]">
        <b-form-radio name="byLimit" :value="{'type':'byLimit'}">
          <div class="header">
            <slot name="txtHeaderByLimit">Guthabengesteuerte Aufladung</slot>
          </div>
          <slot name="txtHeaderByLimitInside"></slot>
          <slot name="txtDescByLimit"></slot>
          <b-row class="threshold">
            <b-col cols="12" class="text">
              <slot name="lblByLimitSecond">Aufladebetrag</slot>
            </b-col>
            <b-col cols="12" class="amount">
              <b-form-select
                v-model="inputThresholdAmount"
                :options="thresholdOptions"
                required
              >
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="trigger">
            <b-col cols="12" class="text">
              <slot name="lblByLimitFirst">Guthabengrenze für die automatische Aufladung</slot>
            </b-col>
            <b-col cols="12" class="amount">
              <b-form-select
                v-model="inputThresholdTrigger"
                :options="triggerOptions"
                required
              >
              </b-form-select>
            </b-col>
          </b-row>
        </b-form-radio>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group :class="['monthly-group', { 'not-active':  topUp.type !== 'monthly' } ]">
        <b-form-radio name="monthly" :value="{'type':'monthly'}">
          <div class="header">
            <slot name="txtHeaderMonthly">Datumgesteuerte Aufladung</slot>
          </div>
          <b-row class="monthly-amount">
            <b-col cols="12" class="text">
              <slot name="lblMonthlyAmount">Aufladebetrag</slot>
            </b-col>
            <b-col cols="12" class="amount">
              <b-form-select
                v-model="inputMonthlyAmount"
                :options="monthlyOptions"
                required
              >
              </b-form-select>
            </b-col>
          </b-row>
        </b-form-radio>
      </b-form-group>
    </b-col>
  </div>

</template>

<script>
import preFilledInput from '../../../../../mixins/preFilledInput'
import configBasedTopUpPrice from '@/mixins/configBasedTopUpPrice'

const constDefaultTrigger = 1000

export default {
  name: 'AutoTopUp',
  methods: {
    buildOptions (optionList) {
      const me = this
      return optionList.map(function (option) {
        return {
          value: option,
          text: me.price(option)
        }
      })
    }
  },
  watch: {
    selectedAutoTopUp: {
      immediate: true,
      handler: function (value) {
        this.$emit('update:trigger', value.trigger)
        this.$emit('update:amount', value.amount)
      }
    }
  },
  computed: {
    selectedAutoTopUp () {
      if (this.topUp) {
        if (this.topUp.type === 'monthly') {
          return Object.assign({}, this.topUp, { amount: this.inputMonthlyAmount })
        }
        if (this.topUp.type === 'byLimit') {
          return Object.assign({}, this.topUp, { amount: this.inputThresholdAmount }, { trigger: this.inputThresholdTrigger })
        }
        return this.topUp
      }
      return {}
    },
    defaultThresholdTrigger: function () {
      if (this.topUp.type === 'byLimit' && this.topUp.trigger !== null && this.topUp.trigger !== undefined) {
        return this.topUp.trigger
      }
      if (this.autoAmounts.threshold.trigger.includes(this.autoAmounts.threshold.defaultTrigger)) {
        return this.autoAmounts.threshold.defaultTrigger
      }
      if (this.autoAmounts.threshold.trigger.length !== 0) {
        return this.autoAmounts.threshold.trigger[0]
      }
      return constDefaultTrigger
    },
    defaultMonthlyAmount: function () {
      if (this.topUp.amount !== null && this.topUp.amount !== undefined) {
        return this.topUp.amount
      }
      return this.autoAmounts.monthly.default
    },
    defaultThresholdAmount: function () {
      if (this.topUp.amount !== null) {
        return this.topUp.amount
      }
      return this.autoAmounts.threshold.default
    },
    triggerOptions: function () {
      return this.buildOptions(this.autoAmounts.threshold.trigger)
    },
    thresholdOptions: function () {
      return this.buildOptions(this.autoAmounts.threshold.amount)
    },
    monthlyOptions: function () {
      return this.buildOptions(this.autoAmounts.monthly.amount)
    }
  },
  mixins: [
    preFilledInput('inputThresholdTrigger', 'defaultThresholdTrigger'),
    preFilledInput('inputMonthlyAmount', 'defaultMonthlyAmount'),
    preFilledInput('inputThresholdAmount', 'defaultThresholdAmount'),
    configBasedTopUpPrice
  ],
  props:
    {
      topUp: {
        type: Object
      },
      autoAmounts: {
        type: Object
      },
      insideActivation: {
        type: Boolean,
        default: false
      }
    }
}
</script>
